/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateBrandingDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	organisationId: z.string().nullable().optional(),
	name: z.string().nullable().optional(),
	website: z.string().url().nullable().optional(),
	logoId: z.string().uuid().nullable().optional(),
	toneOfVoice: z.string().nullable().optional(),
	visualGuidance: z.string().nullable().optional(),
	cornerRadius: z.string().nullable().optional(),
	background: z.string().nullable().optional(),
	foreground: z.string().nullable().optional(),
	accentBackground: z.string().nullable().optional(),
	accentForeground: z.string().nullable().optional(),
	fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }).nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	generateKeyImage: z.boolean().nullable().optional(),
})

export type UpdateBrandingDataSchema = z.infer<typeof updateBrandingDataSchema>
